import { useParams } from "react-router-dom"
import { useNav } from "./useNav";
import { useNavigate } from "react-router-dom";

export const useDefinedParams = (expectedParams: string[]): string[] => {
    const nav = useNavigate();
    const params = useParams();
    const paramsKeys = Object.keys(params);
    if(paramsKeys.length != expectedParams.length) {
        useNav('/404', nav);
        return [];
    }
    else {
        const definedParams: string[] = [];
        paramsKeys.forEach((key) => {
            if(expectedParams.indexOf(key) == -1) {
                useNav('/404', nav);
            }
            else {
                definedParams.push(params[key] as string)
            }
        })
        return definedParams;
    }
}
